import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { trackSignupFree } from '../utils/analytics.js';

function BlogCTA({ location }) {
  return (
    <section className="blog-cta" aria-labelledby={`${location}-cta-title`}>
      <div className="container blog-cta-inner">
        <h2 id={`${location}-cta-title`}>Ready to Put Customer Proof Where Buyers Decide?</h2>
        <p>Create your branded page, share your first request, and publish trust signals without waiting on a developer.</p>
        <Link
          to="/signup"
          className="blog-cta-button"
          onClick={() => trackSignupFree(location)}
        >
          Start FREE In Under 2 Minutes
          <FaArrowRight aria-hidden="true" />
        </Link>
        <p className="blog-cta-trust">✓ Branded page ✓ Website-ready proof ✓ No credit card required</p>
      </div>
    </section>
  );
}

export default BlogCTA;